<template>
  <div class="pages-datetime-picker">
    <date-picker :label-text="dateText" :value="date" @input="updateDate" />
    <time-picker :label-text="timeText" :value="time" @input="updateTime" />
  </div>
</template>

<script>
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'
import moment from 'moment'

export default {
  name: 'date-time-picker',
  components: { DatePicker, TimePicker },
  props: ['dateText', 'timeText', 'value'],
  data: function(){
    return {
      date: '',
      time: ''
    }
  },
  watch: {
    value: function() {
      this.setDateTime()
    }
  },
  methods: {
    updateDate(newDate){
      this.date = newDate;
      this.$emit('dateChanged', newDate)
      this.updateDateTime();
    },
    updateTime(newTime){
      this.time = newTime;
      this.$emit('timeChanged', newTime)
      this.updateDateTime();
    },
    updateDateTime(){
      this.$emit('input', this.dateTimeValue)
    },
    setDateTime(){
      var datetime = this.value ? moment(this.value) : moment()
      this.date = datetime.format("DD-MM-YYYY")
      this.time = datetime.format("HH:mm")
    }
  },
  computed: {
    dateTimeValue(){
      return moment(`${this.date} ${this.time}`, "DD-MM-YYYY HH:mm")
    }
  },
  mounted: function(){
    this.setDateTime()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DateTimePicker.vue